module.exports = __webpack_public_path__ + "static/media/프루.74646386.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/프루.png
// module id = 99
// module chunks = 0